// noinspection TypeScriptValidateTypes

import { FC } from 'react';
import { Props } from './types';
import TextArea from './TextArea';
import { InputStyled } from './style';

interface I<T = unknown> extends FC<T> {
  TextArea: typeof TextArea;
}

const Input: I<Props> = ({ palette, design, size, value, min, max, step, onChange, onBlur, placeholder, name, disabled, onKeyDown, tabIndex, type, className, ...restProps }) => (
  <InputStyled
    palette={palette}
    design={design}
    xsize={size}
    value={value}
    min={min}
    max={max}
    step={step}
    onChange={onChange}
    onBlur={onBlur}
    placeholder={placeholder}
    name={name}
    disabled={disabled}
    onKeyDown={onKeyDown}
    tabIndex={tabIndex}
    type={type}
    className={className}
    {...restProps}
  />
);

Input.TextArea = TextArea;

export default Input;
